export function getModKeyState(
  e: KeyboardEvent,
  key: KeyboardEvent['key'] | 'Accel',
): boolean {
  // Sometimes getModifierState doesn't exist, like when Chrome
  // autocompletes a field.
  if (!e.getModifierState) return false;
  return e.getModifierState(key);
}
